import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/inventoryitems.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import { toastSuccess } from "../../../components/base/Toast";
import Avatar from "../../../components/base/Avatar";
import InventoryItemForm from "../components/InventoryItemForm";
import InventoryItem from "../models/InventoryItem";

export default function InventoryItemsListView() {

  const hub = useHub()
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>(true)

  const [selectedItem, selectedItemSet] = useState<InventoryItem>()


  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteItem = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: InventoryItem) => (
    <FlexRow onClick={() => edit(data)}>
      <div className="">
        <img src={data.thumbUrl} className="w-50px w-xxxl-75px" />
      </div>
      <div className="ms-2">
        <div>
          <a href="#" className="ms-1"
            onClick={e => {
              e.preventDefault();
              edit(data);
            }}>
            {data.name}
          </a>
        </div>
        {
          data.color &&
          <FlexRow className="mt-1">
            <div style={{
              width: 12,
              height: 12,
              backgroundColor: data.color.hexCode,
              border: "1px solid #000",
              borderRadius: 6
            }}>
            </div>
            <div className="fs-7 ms-1">
              {data.color.name}
            </div>
          </FlexRow>
        }
      </div>

    </FlexRow>
  )

  const SKUItem = (data: InventoryItem) => (
    <div>
      <FlexRow>
        <Icon icon="barcode" className="me-1" size={14} />
        <span className="fs-7">{data.sku}</span>
      </FlexRow>
      <FlexRow>
        <span className="text-muted fs-8 me-1">Part No:</span>
        <span className="text-muted fs-8">{data.partNumber}</span>
      </FlexRow>
    </div>
  )

  const PriceItem = (data: InventoryItem) => (
    <div>
      <div className="fs-7">
        {moneyFormatter.format(data.sellingPrice ?? 0)}
      </div>
      <FlexRow>
        <span className="text-muted fs-8 me-1">Cost:</span>
        <span className="text-muted fs-8">
          {moneyFormatter.format(data.costPrice ?? 0)}
        </span>
      </FlexRow>
    </div>
  )

  const CategoryItem = (data: InventoryItem) => (
    <div>
      <div className="fs-7">
        {data.category?.name}
      </div>
      <div className="text-muted fs-8">
        {data.category?.fullPathName}
      </div>
    </div>
  )

  const VendorItem = (data: InventoryItem) => (
    <div>
      <div className="fs-7">
        {data.vendor?.name}
      </div>
      <div className="text-muted fs-8">
        {data.brand?.name} &gt; {data.model?.name}
      </div>
    </div>
  )

  const ContainerItem = (data: InventoryItem) => (
    <div>
      <div className="fs-7">
        {data.primaryContainer?.name}
      </div>
      <div className="text-muted fs-8">
        ID: {data.primaryContainer?.containerID}
      </div>
    </div>
  )

  const CreatedItem = (data: InventoryItem) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: InventoryItem) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageInventoryItems");
    setPage("Inventory Items", "Inventory", "Inventory");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Item"
          apiRoute={API_ROUTES.InventoryItems}
          filteringProps={filteringProps}
          //sortingProps={sortingProps}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteInventoryItems")} deleteCustom={deleteItem}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="sku">
            <SKUItem />
          </DataTableField>

          <DataTableField title="price">
            <PriceItem />
          </DataTableField>

          <DataTableField title="category">
            <CategoryItem />
          </DataTableField>

          <DataTableField title="vendor">
            <VendorItem />
          </DataTableField>

          <DataTableField title="container">
            <ContainerItem />
          </DataTableField>


          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        createModal &&
        <InventoryItemForm
          onClose={() => {
            createModalSet(false)
            selectedItemSet(undefined)
          }}
          onSave={() => {
            refreshSet(true)
          }} />
      }


      {
        editModal && selectedItem &&
        <InventoryItemForm
          model={selectedItem}
          onClose={() => {
            createModalSet(false)
            selectedItemSet(undefined)
          }}
          onSave={() => {
            refreshSet(true)
          }} />
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-item"
          title="Delete Item"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onClose={() => {
            deleteModalSet(false)
            selectedItemSet(undefined)
          }}
          onSubmit={(body, callback) => {

            hub.Post(API_ROUTES.InventoryItems + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Item has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          }}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the item?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
